import { render } from "./ServicesProviders.vue?vue&type=template&id=05781626"
import script from "./ServicesProviders.vue?vue&type=script&lang=js"
export * from "./ServicesProviders.vue?vue&type=script&lang=js"

import "./ServicesProviders.vue?vue&type=style&index=0&id=05781626&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__